import React from 'react';
import { ComponentWrapper } from '@ihsm/ui-shared';
import { FullViewLoading } from 'shared/components/FullViewLoading';
import { generateCss } from '../utils';
import './PageContent.scss';

interface PageContentProps {
  searchTree?: React.FC | React.ReactNode | React.ReactElement;
  headerControls?: React.FC | React.ReactNode | React.ReactElement;
  viewControls?: React.FC | React.ReactNode | React.ReactElement;
  forceLoadingScreen?: boolean;
  disableLoadingView?: boolean;
  forceNoDataScreen?: boolean;
  className?: string;
  overrideCss?: boolean;
}

export const PageContent: React.FC<PageContentProps> = ({
  children,
  searchTree,
  headerControls,
  viewControls,
  forceLoadingScreen = false,
  disableLoadingView = false,
  forceNoDataScreen = false,
  className,
  overrideCss = false,
}) => {
  const {
    pageContentCss,
    pageContentSearchTree,
    pageContentContainer,
    pageContentContent,
  } = generateCss({ customClassName: className, overrideCss });

  return (
    <FullViewLoading
      forceLoadingScreen={forceLoadingScreen}
      disableLoadingView={disableLoadingView}
      forceNoDataScreen={forceNoDataScreen}
    >
      <div className={pageContentCss}>
        {searchTree ? (
          <div className={pageContentSearchTree}>
            <ComponentWrapper component={searchTree} />
          </div>
        ) : null}

        <div className={pageContentContainer}>
          {headerControls ? (
            <ComponentWrapper component={headerControls} />
          ) : null}

          {viewControls ? <ComponentWrapper component={viewControls} /> : null}

          <div className={pageContentContent}>{children}</div>
        </div>
      </div>
    </FullViewLoading>
  );
};
